import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const help = createReducer(
  {
    list: [],
  },
  {
    [types.GET_HELP_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });

      return newState;
    },
    [types.GET_HELP_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        content: action.content,
        loading: false,
      });
      return newState;
    },
    [types.GET_HELP_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        content: '',
        error: action.error,
        loading: false,
      });

      return newState;
    },
  },
);

export { help as default };
